<style scoped>

  .main-segment {
    min-height: 350px;
  }

  #no-birthdays-segment {
    min-height: 310px;
  }

</style>

<template>

  <div class="ui segment main-segment" :class="{ loading }">
    
    <h4 class="ui dividing header">
      Aniversariantes do Mês
      <span class="ui small label">
        <i class="birthday cake icon"></i> {{ currentMonthLabel }}
      </span>
    </h4>  

    <table v-if="!loading && users.length > 0" class="ui celled table">
      <thead v-if="$isDesktop">
        <tr>
          <th>Dia</th>
          <th>Nome</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in users" :key="index">
          <td>
            <strong class="mobile-only">Dia: </strong>
            {{ user.birthDay }}
          </td>          
          <td>
            <strong class="mobile-only">Nome: </strong>
            <user-group-icon :group="user.group" />
            <span class="m-l-5">{{ user.name.trim() }}</span>
            <div v-if="user.birthDay == currentDay" class="ui small teal label m-l-10">Faz aniversário hoje</div>            
          </td>           
        </tr>               
      </tbody>
    </table>

    <div v-if="!loading && users.length == 0" class="ui middle aligned grid" id="no-birthdays-segment">
      <div class="sixteen wide column">
        <div class="ui basic centered segment">
          <div class="ui icon header grey text">
            <i class="info circle icon"></i>
            Nenhum aniversariante esse mês
          </div>              
        </div>
      </div>
    </div>

  </div>    

</template>

<script>

  import moment from "@/utils/moment"
  import UserService from "@/services/user-service"
  import UserGroupIcon from "@/components/user-group-icon"

  export default {
    
    name: "BirthDays",

    data() {
      return {
        service: new UserService(),
        users: [],
        loading: true,
        currentDay: new Date().getDate(),
        currentMonthLabel: "",
      }
    },

    components: {
      UserGroupIcon,
    },

    created() {
      this.setCurrentMonthLabel()
      this.loadUsers()
    },    

    methods: {

      setCurrentMonthLabel() {
        
        const label = moment().format("MMMM [de] YYYY")
        const firstChr = label.substring(0, 1).toUpperCase()

        this.currentMonthLabel = firstChr + label.substring(1)
      },

      async loadUsers() {

        this.loading = true

        try {

          this.users = await this.service.findMonthBirthDays()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>